import {WidgetLinkingGroupId} from '../enums/widget-linking-group';

export interface DisplayWidgetLinkingGroup {
    id: WidgetLinkingGroupId;
    className: string;
    label: string;
}

const DISPLAY_WIDGET_LINKING_GROUPS: DisplayWidgetLinkingGroup[] = [
    {
        id:        WidgetLinkingGroupId.NONE,
        className: '-no-linking-group',
        label:     'components.widgets.linking-groups.menu_item_group_none'
    },
    {
        id:        WidgetLinkingGroupId.RED,
        className: '-red-linking-group',
        label:     'components.widgets.linking-groups.menu_item_group_red'
    },
    {
        id:        WidgetLinkingGroupId.ORANGE,
        className: '-orange-linking-group',
        label:     'components.widgets.linking-groups.menu_item_group_orange'
    },
    {
        id:        WidgetLinkingGroupId.YELLOW,
        className: '-yellow-linking-group',
        label:     'components.widgets.linking-groups.menu_item_group_yellow'
    },
    {
        id:        WidgetLinkingGroupId.GREEN,
        className: '-green-linking-group',
        label:     'components.widgets.linking-groups.menu_item_group_green'
    },
    {
        id:        WidgetLinkingGroupId.BLUE,
        className: '-blue-linking-group',
        label:     'components.widgets.linking-groups.menu_item_group_blue'
    },
    {
        id:        WidgetLinkingGroupId.MAGENTA,
        className: '-magenta-linking-group',
        label:     'components.widgets.linking-groups.menu_item_group_magenta'
    },
    {
        id:        WidgetLinkingGroupId.ALL,
        className: '-all-linking-groups',
        label:     'components.widgets.linking-groups.menu_item_group_all'
    }
];

export class DisplayWidgetLinkingGroupFactory {

    public static getDisplayWidgetLinkingGroups(): DisplayWidgetLinkingGroup[] {
        return DISPLAY_WIDGET_LINKING_GROUPS;
    }

    public static getDisplayWidgetLinkingGroupByType(type: WidgetLinkingGroupId): DisplayWidgetLinkingGroup {
        return DISPLAY_WIDGET_LINKING_GROUPS.find(group => group.id === type);
    }

}
